module.exports = __webpack_public_path__ + "img/try1.a87e96ad.png";